/**
 * Article Image Gallery Carousel
 */
import Flickity from 'flickity';

function articleContentImageGalleryCarousel() {
  const config = {
    dom: {
      carousel: 'js-article-content-image-gallery-carousel',
      zoomModalTrigger: 'js-article-content-image-gallery-zoom-modal-trigger',
      zoomModalCarousel: 'js-article-content-image-gallery-zoom-modal-carousel',
      zoomModalCloseButton: 'js-article-content-image-gallery-zoom-modal-close-button',
    },
    cls: {
      overflowHidden: 'overflow-hidden',
    },
    flickityOpts: {
      prevNextButtons: true,
      pageDots: true,
      arrowShape: '',
      wrapAround: true,
    },
  };

  const c = config;
  const $carousels = [...document.querySelectorAll(`.${c.dom.carousel}`)];

  /**
   * Init
   */
  function init() {
    if (!$carousels?.length) {
      return;
    }

    $carousels.forEach(($carousel) => {
      // eslint-disable-next-line no-unused-vars
      const onPageCarousel = makeCarousel($carousel, c.flickityOpts);
      const $zoomCarouselTriggers = [...$carousel.querySelectorAll(`.${c.dom.zoomModalTrigger}`)];

      $zoomCarouselTriggers.forEach(($zoomCarouselTrigger) => {
        initZoomCarousel($zoomCarouselTrigger, $carousel);
      });
    });
  }

  /**
   * Init Zoom Carousel
   * @param {HTMLElement} $zoomCarouselTrigger
   * @param {HTMLElement} $carousel
   */
  function initZoomCarousel($zoomCarouselTrigger, $carousel) {
    const { metaObjectId } = $zoomCarouselTrigger.dataset;

    __.addEvent({
      id: $zoomCarouselTrigger.parentElement,
      event: 'click',
      className: c.dom.zoomModalTrigger,
      fn: () => {
        const $modal = document.getElementById(`articleContentImageGalleryZoomModal-${metaObjectId}`);
        const $zoomCarousel = $modal.querySelector(`.${c.dom.zoomModalCarousel}`);

        // Open modal
        $modal.showModal();
        __.addClass(document.body, c.cls.overflowHidden);

        // Set initial index of zoom modal carousel to match the index of the clicked image
        const onPageCarouselData = Flickity.data($carousel);
        const zoomModalCarousel = makeCarousel($zoomCarousel, {
          ...c.flickityOpts,
          initialIndex: onPageCarouselData.selectedIndex,
        });

        // Close modal
        __.addEvent({
          id: $modal,
          event: 'click',
          className: c.dom.zoomModalCloseButton,
          fn: () => handleModalClose($modal, zoomModalCarousel),
        });

        __.addEvent({
          id: $modal,
          event: 'cancel',
          className: c.dom.zoomModalCloseButton,
          fn: () => handleModalClose($modal, zoomModalCarousel),
        });
      },
    });
  }

  /**
   * Handle Modal Close
   */
  function handleModalClose($modal, zoomModalCarousel) {
    __.removeClass(document.body, c.cls.overflowHidden);
    zoomModalCarousel.destroy();

    __.removeEvent({
      id: $modal,
      event: 'click',
      className: c.dom.zoomModalCloseButton,
      fn: handleModalClose,
    });

    __.removeEvent({
      id: $modal,
      event: 'cancel',
      className: c.dom.zoomModalCloseButton,
      fn: handleModalClose,
    });
  }

  /**
   * Make Carousel
   * @param {HTMLElement} $carousel
   */
  function makeCarousel($carousel, options) {
    return new Flickity($carousel, options);
  }

  return init();
}

export default articleContentImageGalleryCarousel;
